import React, { useState } from "react";
import ArticleCard from "./ArticleCard";

const PAGE_SIZE = 9;

export default function ArticleGrid({ title, articles }) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const visibleArticles = articles.slice(0, visibleCount);
  const hasMore = visibleCount < articles.length;

  return (
    <section className="mu-section pt-0">
      <div className="container">
        {title && <h2 className="section-title mb-4">{title}</h2>}

        {visibleArticles.length === 0 ? (
          <p className="section-sub">No stories match this category yet — check back soon.</p>
        ) : (
          <div className="row g-4">
            {visibleArticles.map((a) => (
              <div className="col-md-6 col-lg-4" key={a.slug}>
                <ArticleCard article={a} />
              </div>
            ))}
          </div>
        )}

        {hasMore && (
          <div className="text-center mt-5">
            <button className="btn-mu-outline" onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}>
              Load More Posts
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
